<template>
  <div v-loading="loading">
<!--    <p>aaaa</p>-->
    <el-card>
      <div slot="header" class="clearfix">

        <el-row>
          <el-col :md="12">
            <div v-if="workingProduct">
              <!-- <el-button
                @click="routeGo({params:{productid:'all'}})"
                icon="el-icon-circle-close"
                type="text"
              ></el-button>-->
              <strong>{{workingProduct.name}}</strong>
            </div>
          </el-col>
          <el-col :md="12">
            <el-button
              type="default"
              style="float: left;"
              @click="toogleReportDate='report_all'"
              title="check all"
            >
              <i class="material-icons">check_box</i>
            </el-button>
            <el-button
              type="default"
              style="float: left;"
              @click="toogleReportDate='report_none'"
              title="uncheck all"
            >
              <i class="material-icons">check_box_outline_blank</i>
            </el-button>
            <el-button
              title="Full pickup list"
              style="float: right;"
              type="success"
              plain
              @click="goPdf('sapplier-bookings.html',{printimes:1,...bookingQuery},d_filename);"
            >
              <i class="material-icons">print</i>
            </el-button>
            <!-- <el-button
              title="Register financial transactions"
              style="float: right;"
              type="warning"
              plain
              @click="registerTransDrafts()"
            >
              <i class="material-icons">menu_book</i>
            </el-button>-->
          </el-col>
        </el-row>
      </div>
      <s-table
        defaultSort="in"
        :colDefinitions="colcustomerDefinitions"
        modx-processor="vue_booking/getlist"
        :r-query="bookingQuery"
        :pagging="40"
        :lazyLoader="true"
        :addEmptyLine="false"
        @cell-clicked="goToCustomer"
        @cell-change="handleBooking"
        :rowClassFactory="styler"
        @dataFetched="toogleReportDate=null"
      ></s-table>
    </el-card>
  </div>
</template>

<script>
import * as api from "~/api/resource";

import { mapGetters, mapActions } from "vuex";
// import { async } from "q";
import commons from "~/mixins/commons";
export default {
  mode: {
    type: String,
    default: "simple",
  },
  mixins: [commons],
  async mounted() {
    var vm = this;

    this.loading = false;
  },
  watch: {},
  methods: {
    async registerTransDrafts() {
      const data = await api.getModxList("vue_route", {
        limit: 0,
        daterange: this.$route.query.range,
        productId: this.workingProduct.id,
        createTransDrafts: true,
      });
      // daterange: 01/01/2019-31/12/2019
      // sapplier_ids[]: 2
    },
    styler(e) {
      if (e.row.status == "canceled") return "canceled-row";
      return "";
    },
    goToCustomer(val) {
      _log_("suggest..", val);
      if (val.column.property == "customer") {
        //package_services
        this.routeGo({
          name: "package_services",
          params: { tripid: val.row.tripid, kind: "package" },
          query: { selected_customer: val.row.customer_id },
        });
        return;
      }
      if (val.column.property == "go_report") {
        val.row.go_report = !val.row.go_report;
        this.handleBooking(val);
      }
      // var Q = {}; //this.$route.params
      // Q.customerid = val.row ? val.row.id : val;
      // _log_("hell yes", Q);
      // this.routeGo({
      //   name: "customer",
      //   params: Q
      // });
      // this.showcustomer = true;
    },
    // goToCustomer(val) {
    //   var Q = {}; //this.$route.params
    //   Q.customerid = val.row ? val.row.id : val;
    //   _log_("hell yes", Q);
    //   this.routeGo({
    //     name: "customer",
    //     params: Q
    //   });
    //   this.showcustomer = true;
    // },
    async handleBooking(data) {
      await api.updateProcessor("vue_booking/update", data.row);
    },
  },
  data() {
    return {
      loading: true,
      errors: {},
      tripDada: null,
      toogleReportDate: null,
      showcustomer: false,
      bookedDates: [],
      editcustomerData: null,
      booking: REPO.booking,
    };
  },
  computed: {
    d_filename() {
      let nm = this.workingProduct.name + "_" + this.formatDate(this.unxnow());
      nm = nm.split("(");
      nm = nm.join("_");
      nm = nm.split(".");
      nm = nm.join("_");
      nm = nm.split(")");
      nm = nm.join("_");
      nm = nm.split(" ");
      nm = nm.join("_");
      _log_("go sap q ", nm);
      return nm;
    },
    bookingQuery() {
      var q = {
        ...this.$route.params,
        ...this.$route.query,
        toogleReportDate: this.toogleReportDate,
        type: "sappliers",
      };
      return q;
    },
    colcustomerDefinitions() {
      var rw = "580px";
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        // {
        //   editable: true,
        //   editorcomponent: {
        //     label: "",
        //     is: "el-checkbox"
        //   },
        //   prop: "go_report",
        //   width: 80,
        //   label: "Rep.",
        //   formatter: function(val, colDefs, row, vm) {
        //     // _log_(">>>>" + val, row);
        //     return val ? '<i class="material-icons">done_outline</i>' : "";
        //   }
        // },
        {
          prop: "go_report",
          width: 110,
          label: "Report",
          action: "button",
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return val
              ? '<i class="material-icons">done_outline</i>'
              : '<i class="material-icons">check_box_outline_blank</i>' +
                  vm.formatDate(row.note_reportedDate);
          },
        },
        { prop: "pax", width: 70, label: "Pax" },
        {
          // editable: true,
          // editorcomponent: {
          //   type: "date",
          //   is: "s-dater",
          //   displayFormat: "dd/MM/yyyy"
          // },
          prop: "in",
          width: 140,
          label: "In",
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return vm.formatDate(val);
          },
        },
        {
          // editorcomponent: {
          //   type: "date",
          //   displayFormat: "dd/MM/yyyy",
          //   is: "s-dater"
          // },
          prop: "out",
          width: 140,
          // editable: true,
          label: "Out",
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return vm.formatDate(val);
          },
        },
        {
          prop: "route_pupAid",
          width: "130px",
          label: "Out",
          // editable: true,
          label: "Pick Up",
          // editorcomponent: {
          //   is: "s-remote-select",
          //   classModel: "pup",
          //   queryProp: "q",
          //   labelProp: "name",
          //   valueProp: "id",
          //   extraQueryParams: { mode: "select" },
          //   filterable: true,
          //   clearable: true,
          //   multiple: false
          // },
          // editWhen(rowData) {
          //   // _log_('???E..',rowData)
          //   if (rowData.serviseType != "ACCOMMODATION") return true;
          //   return false;
          // },
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return row.pupnameA;
          },
        },
        {
          prop: "route_pupZid",
          width: "130px",
          label: "Out",
          // editable: true,
          label: "Drop Off",
          // editorcomponent: {
          //   is: "s-remote-select",
          //   classModel: "pup",
          //   queryProp: "q",
          //   labelProp: "name",
          //   valueProp: "id",
          //   extraQueryParams: { mode: "select" },
          //   filterable: true,
          //   clearable: true,
          //   multiple: false
          // },
          // editWhen(rowData) {
          //   _log_('???E..',rowData)
          //   if (rowData.serviseType != "ACCOMMODATION") return true;
          //   return false;
          // },
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return row.pupnameZ;
          },
        },
        {
          prop: "customer",
          width: "",
          label: "Customer Name",
          clickable: true, // "button"
        },
        // { prop: "reference", width: "", label: "Referense" },
        { prop: "trip_title", width: "120px", label: "Package" },
        { prop: "note_room", width: "100px", label: "Rm.Type" },
        {
          prop: "note_activity",
          width: 150,
          label: "Activity Note",
          editable: true,
          formatter: function (val, colDefs, row, vm) {
            var msg = val ? val : "";
            if (row.note_in && row.note_in + "" != row.in + "")
              msg += " !!correct check in:" + vm.formatDate(row.note_in);
            if (row.note_out && row.note_out + "" != row.out + "")
              msg += " !!correct check out:" + vm.formatDate(row.note_out);
            return msg;
          },
        },
        {
          prop: "note_accommodation",
          width: 150,
          label: "Accom. Note",
          editable: true,
        },

        // { prop: "country", width: "", label: "Country" },
      ];
    },
    datepickerOptions() {
      return {
        disabledDate: this.isBookable,
      };
    },
  },
};
</script>
